import {BaseContainerSelect, BaseContainerSelectProps} from "./BaseContainerSelect";
import {useMemo} from "react";
import {ContainerSelectorProps, containersSelector, useGetAllContainersQuery} from "@ots-frontend/ots-data";

export type ContainerSelectProps = Omit<BaseContainerSelectProps, "entities" | "loading"> & {
  selector?: ContainerSelectorProps
}

export const ContainerSelect = (props: ContainerSelectProps) => {
  const {selector, ...rest} = props;

  const selectContainers = useMemo(() => {
    return containersSelector();
  }, []);

  const {containers, isLoading} = useGetAllContainersQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      containers: selectContainers(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseContainerSelect entities={containers} loading={isLoading} {...rest} />;
};
